import React, { useState,useEffect } from "react";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import Documents from "../../../../components/common/forms/Documents";
import FormPayment from "../../../../components/common/forms/FormPayment";
import { toast, ToastContainer } from "react-toastify";
import {
  exim_registration_v2,
  exim_registration_v3,
  Exim_upload_details,
  Exim_details_of_shareholder,
  exim_shareholder,
} from "./EximCodeRegistrationForm";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "react-hook-form";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import api from "../../../../api/api";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import BackButton from "../../../../components/common/backbutton/BackButton";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";


const EximCodeRegistration = () => {
  const { register, handleSubmit, unregister } = useForm();
  const [shareHolders, setShareHolders] = useState([
    {
      ...exim_shareholder,
      id: uuidv4(),
    },
  ]);
  const [fieldChnage, setFieldChnage] = useState(true);

  const [docsOutput, setDocsOutput] = useState([]);
  const [uploadProof, setUploadProof] = useState('')

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)



  const [paymentRangeList, setPaymentList] = useState([])
  const [amount, setAmount] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [dueAmount, setDueAmount] = useState(null)
  const [paidAmount, setPaidAmount] = useState(null)


   // For amount calculation
   useEffect(() => {
    if(amount > 0){
      let arr = paymentRangeList.filter((item) => { 
        return amount >= parseInt(item.range_start) && amount <= parseInt(item.range_end)
      })
      console.log(arr)

      arr.length > 0  && setTotalAmount(arr[0]?.amount)
    }else{
      setTotalAmount(0)
    }
  }, [amount, paymentRangeList])

  
   // getting current user
   useEffect(()=> {
    api.get("/users/me/")
    .then(response=> {
        setDueAmount(response.due_amount)
    }).catch(error=> {

    }) 
  },[])

   // for filtering by company_type and show in Modal
  useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=exim_code')
    .then(response=> {
        // console.log(response.data)
        setPaymentList(response.data)
    }).catch(error=> {
       console.log(error)
    })
  }, [])



  useEffect(()=> {
    setAmount(0)
  },[fieldChnage])



  useEffect(() => {
    if(fieldChnage){
      exim_registration_v3.map((item)=> {
        unregister(item.name)
      })
    }else{
        exim_registration_v2.map((item)=> (
          unregister(item.name)
        ))
    }

  }, [unregister, fieldChnage])
  



  const ekal = () => {
    setFieldChnage(true);
  };
  const bahul = () => {
    setFieldChnage(false);
  };

  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.documents = docsOutput;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof : uploadProof,
          company : response.data.company_id,
          transaction_type: "credit"
       
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        toast.error("Data Registration Failed.");
      });
  };

  let data = [];
  // const initialState = {image:"", document_name:""}

  Exim_upload_details.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
  });

  return (
    <div>
      <form className="md:px-10 px-3 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
          Exim Code Registration Form (आयात निर्यात गर्ने उद्देश्यले भन्सारमा
          दर्ता गर्नको लागि)
        </p>
        <div className="text-primary-blue   font-Calistoga text-lg my-6 flex justify-between ">
          <div className="underline">1. Company Name & Other Details</div>
          <div className="">
            Firm no. : <span className="text-primary-blue">123</span>
          </div>
        </div>

        <div className="my-3">
        {(user?.user_type === "ST" || user?.user_type === "AD") && (
          <AdminSearchCustomer setUserId={setUserId} />
        )}
      </div>

        <CompanySearch register={register} />
        <div className="border-primary-blue mt-3 font-Laila border-2">
                  <div className="flex md:flex-row items-center border-b border-primary-blue font-Laila flex-col ">
                    <div className="border-primary-blue text-center text-primary-red  py-2  md:border-r md:w-[30rem]  text-lg font-bold">
                      कम्पनीको नाम
                    </div>

                    <div className="border-primary-blue flex md:flex-col-1 text-primary-red  border-r  py-2 w-full text-base font-bold sm:text-lg">
                      <p>नेपालीमा : </p>
                      <input
                        className="outline-none text-primary-blue pl-3 "
                        {...register(`company_name_nep`, {
                          // required: false,
                        })}
                      />
                    </div>
                    <div className="border-primary-blue flex text-primary-red   py-2 w-full text-base font-bold sm:text-lg">
                      <p>English मा : </p>
                      <input
                        className="outline-none text-primary-blue pl-3 "
                        {...register(`company_name`, {
                          // required: false,
                        })}
                      />
                    </div>
                  </div>
                  <div className="flex border-b border-primary-blue w-full">
                    <div className="border-primary-blue text-center text-primary-red border-r  py-2 md:w-[15rem]    text-lg font-bold">
                      कम्पनीको ठेगाना
                    </div>
                    <div className="border-primary-blue flex text-primary-red  w-full text-base font-bold sm:text-lg">
                      <input
                        className="outline-none text-primary-blue pl-3"
                        {...register(`company_address`, {
                          // required: false,
                        })}
                      />
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="border-primary-blue text-primary-red  text-center border-r   py-2 md:w-[30.5rem] text-lg font-bold">
                      ब्यवसायको प्रकार
                    </div>
                    <div className="flex flex-wrap border-primary-blue gap-3 justify-center border-r items-center text-primary-red  w-full  text-base  sm:text-lg">
                      <div className="border-primary-blue border-r bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                        <label htmlFor="ekal" >
                          एकल{" "}
                        </label>
                        <input
                        onClick={ekal}
                          type="radio"
                          name="radio-btn"
                          id="ekal"
                          value="ekal"
                          {...register("business_type", { required: false })}
                        />
                      </div>

                      <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                        <label htmlFor="bahul" >
                          साझेदारी
                        </label>
                        <input
                        onClick={bahul}
                          type="radio"
                          name="radio-btn"
                          value="bahul"
                          id="bahul"
                          {...register("business_type", { required: false })}
                        />
                      </div>
                      <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                        <label htmlFor="prali" >
                        प्रा.लि. कम्पनी
                        </label>
                        <input
                        onClick={bahul}
                          type="radio"
                          name="radio-btn"
                          value="prali"
                          id="prali"
                          {...register("business_type", { required: false })}
                        />
                      </div>
                      {/* <div className="rounded-xl bg-red-600 px-3 py-1 text-white">
                    test
                    </div> */}
                    </div>
                    <div className="flex flex-wrap border-primary-blue text-primary-red  gap-3 pl-5 w-full items-center text-base font-bold sm:text-lg">
                      ब्यवसायको प्रकृती:
                      <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                        <label htmlFor="trading"> ट्रेडिब </label>
                        <input
                          type="radio"
                          name="radio-btn"
                          value="trading"
                          className="bg-yellow"
                          // {...register("registration_nature", { required: false, })}
                          id="trading"
                        />
                      </div>
                      <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                        <label htmlFor="udhyog">औधोगिक</label>
                        <input
                          type="radio"
                          name="radio-btn"
                          value="industrial"
                          //  {...register("registration_nature", { required: false, })}
                          id="udhyog"
                        />
                      </div>
                    </div>
                  </div>
                </div>
       
       
       
        {/* business and company details */}
        {/* <div className="overflow-x-auto">
          <div>
            <div>
              <div className="flex">
                <div className="border-primary-blue text-primary-red border px-3 text-lg font-bold">
                  कम्पनीको नाम
                </div>

                <div className="border-primary-blue flex text-primary-red border px-3 text-base font-bold sm:text-lg">
                  <p>नेपालीमा : </p>
                  <input  className="outline-none pl-1 text-primary-blue"
                  {...register(`company_name_nep`, {
                    // required: false,
                  })}
                  />
                </div>
                <div className="border-primary-blue flex text-primary-red border text-base font-bold sm:text-lg">
                  <p>English मा : </p>
                  <input  className="outline-none pl-1 text-primary-blue "
                  {...register(`company_name`, {
                    // required: false,
                  })}
                  />
                </div>
              </div>
              {/* <div className="flex">
                <div className="border-primary-blue text-primary-red border  text-lg font-bold">
                  कम्पनीको ठेगाना
                </div>
                <div className="border-primary-blue flex text-primary-red border 6 text-base font-bold sm:text-lg">
                  <input className="outline-none pl-1 text-primary-blue "
                  {...register(`company_address`, {
                    // required: false,
                  })}
                  />
                </div>
              </div>
              <div className="flex">
                <div className="border-primary-blue text-primary-red border px-3 text-lg font-bold">
                  ब्यवसायको प्रकार
                </div>
                <div className="flex border-primary-blue text-primary-red border px-3 text-base font-bold sm:text-base">
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
                    <label htmlFor="">एकल </label>
                    <input type="radio" name="radio-btn" id=""
                    value="ekal" 
                    {...register("business_type", { required: false, })}
                    />
                  </div>
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
                    <label htmlFor=""> साझेदारी</label>
                    <input type="radio" name="radio-btn" id="" 
                    value="bahul"
                    {...register("business_type", { required: false, })}
                    />
                  </div>
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
                    <label htmlFor=""> प्रा.लि. कम्पनी</label>
                    <input type="radio" name="radio-btn" id="" />
                  </div>
                </div>
                <div className="flex border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                  ब्यवसायको प्रकृती:
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
                    <label htmlFor="">एकल </label>
                    <input type="radio" name="radio-btn" id=""
                     // {...register("registration_nature", { required: false, })}
                    />
                  </div>
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
                    <label htmlFor="">एकल</label>
                    <input type="radio" name="radio-btn" id=""
                    //  {...register("registration_nature", { required: false, })}
                    />
                  </div>
                </div>
              </div> */}
        {/* </div> */}
        {/* </div> */}

        {/* </div> */}
        {/* business and company details close*/}

        <div className="w-full flex gap-1 md:flex-row flex-col items-center">
          {fieldChnage === true ? (
            <>
              <div className="mt-4 border-2 border-primary-blue font-Laila  w-full">
                <div className="">
                  {/* <div> */}
                  {exim_registration_v2.map((item, i) => {
                    const { name, validation, ip1, type } = item;
                    return (
                     
                        <div
                          key={i}
                          className=" border-primary-blue flex flex-col border-b md:flex-row  "
                        >
                          <div className="text-primary-red px-5 py-2  text-center sm:!w-[350px] font-bold">
                            {ip1}
                          </div>
                          <div className="md:border-l-2 border-t md:border-t-0 border-primary-blue text-primary-red  px-10 text-lg font-bold">
                            <input
                              type={type}
                              className=" w-full py-2 outline-none "
                              {...register(`${name}`, { required: false,
                              onChange: (e) => {e.target.name === "total_capital" && setAmount(e.target.value)} })}

                              
                    
                            />
                          </div>
                        </div>
                    
                    );
                  })}

                  {/* </div> */}
                </div>
                <div className="bg-red-200 border-spacing-2 border-primary-blue  border-t text-primary-blue font-bold  py-5 text-center">
                  पुँजी र प्रकृतीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                  <span className="text-red-600">रु.{totalAmount}।– </span> मात्र
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="mt-4 border-2 border-primary-blue font-Laila w-full">
                <div>
                  {/* <div> */}
                  {exim_registration_v3.map((item, i) => {
                    const { name, validation, ip1, type } = item;
                    return (
                     
                        <div
                          key={i}
                          className=" border-primary-blue flex flex-col border-b md:flex-row  "
                        >
                          <div className="text-primary-red text-center  px-5 py-2 sm:!w-[350px] font-bold">
                            {ip1}
                          </div>
                          <div className="md:border-l-2 border-t md:border-t-0 border-primary-blue text-primary-red  px-10 text-lg font-bold">
                            <input
                              type={type}
                              className=" w-full py-2 outline-none "
                              {...register(`${name}`, { required: false,
                             onChange: (e) => {e.target.name === "total_capital" && setAmount(e.target.value)} })}           
                
                            />
                          </div>
                        </div>
                     
                    );
                  })}

                  {/* </div> */}
                </div>
                <div className="bg-red-200 border-spacing-2 border-primary-blue  border-t text-primary-blue font-bold  py-5 text-center">
                  साझेदारहरुको संख्या, ब्यवसायको प्रकृति र पुँजीको तपाईको जम्मा
                  लाग्ने रकम <span className="text-red-600">रु.{totalAmount}।– </span>{" "}
                  मात्र
                </div>
              </div>
            </>
          )}

          <div>
            <div>
              <div className="border-primary-red text-primary-blue w-fit font-Laila text-center rounded-full border-2 p-2 text-base ">
                प्राली कम्पनी वा ब्यव्साय भन्सार कार्यालयम ईक्जिम कोड दर्ता गर्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ <span data-bs-toggle="modal" data-bs-target="#exampleModalEdit" className="text-primary-red cursor-pointer"
                > Click
                </span>  गर्नुहोस ।
                <PrivateCompanyModal
                 paymentRangeList={paymentRangeList}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="mt-4">
          <div>
            <div>
              {exim_registration_v3.map((item, i) => {
                const { name, validation, ip1, type } = item;
                console.log(item);
                return (
                  <div
                    key={i}
                    className="border-primary-blue flex flex-col md:flex-row"
                  >
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      {ip1}
                    </div>
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      <input type={type} 
                       className="border-primary-blue w-full  py-2 pl-3 outline-none  text-primary-blue"
                       {...register(`${name}`, { required: false })}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}

        {/* <div className="mt-4">
          <div>
            <div>
              {exim_registration_v3.map((item, i) => {
                const { name, validation, ip1, type } = item;
                console.log(item);
                return (
                  <div
                    key={i}
                    className="border-primary-blue flex flex-col md:flex-row"
                  >
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      {ip1}
                    </div>
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      <input type={type} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}
        <p className="text-primary-blue font-Calistoga text-lg mt-5 underline">
          2. Details of Share Holders
        </p>
        <DetailsOfShareHolders
          DetailShareholder={Exim_details_of_shareholder}
          needed_share={exim_shareholder}
          setShareHolders={setShareHolders}
          shareHolders={shareHolders}
          // initialState={initialState}
        />

        {/* this should not be included here */}
        <div className="text-primary-blue font-Calistoga text-lg mt-6 mb-6 underline">
         3. Objective
          <span className="text-primary-blue underline font-Laila mx-2 ">
            (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
          </span>
        </div>
        <MainObjectives register={register} />

        {/* details of share holders open */}
        {/* 
        <div className="">
          <div className="flex justify-end">
            <a className="add-record cursor-pointer" data-added={0}>
              <i className="">
                <svg
                  className="text-primary-blue h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M16 2A14.172 14.172 0 0 0 2 16a14.172 14.172 0 0 0 14 14a14.172 14.172 0 0 0 14-14A14.172 14.172 0 0 0 16 2Zm8 15h-7v7h-2v-7H8v-2h7V8h2v7h7Z"
                  />
                  <path fill="none" d="M24 17h-7v7h-2v-7H8v-2h7V8h2v7h7v2z" />
                </svg>
              </i>
            </a>
          </div>
          {/* share holder details form */}
        {/* <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                <div className="min-w-[1300px] overflow-x-auto">
                  <div id="tbl_posts">
                    <div>
                      <div>
                        <div className="border-primary-blue  text-primary-red border text-lg font-bold">
                          क्र. स.
                        </div>
                        <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          शेयर सदस्यहरु वा साझेदार सदस्यहरुको नाम
                        </div>
                        <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          शेयर सदस्यको नागरीकता
                        </div>
                        <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          पासपोर्ट साईजको फोटो
                        </div>
                      </div>
                    </div>
                    <div id="tbl_posts_body">
                      <div id="rec-1" className="border-primary-blue border">
                        <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                          1
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "none" }}>
                    {/* div row add */}
        {/* <div id="sample_table">
                      <div>
                        <div id="" className="border-primary-blue border">
                          <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                            <span className="sn">1</span>
                          </div>
                          <div className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </div>
                          <div className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </div>
                          <div className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </div>
                          <div className="p-0">
                            <input
                              type="file"
                              name=""
                              className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                              id=""
                            />
                          </div>
                          <div className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </div>
                          <div className="p-0">
                            <input
                              type="text"
                              name=""
                              className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                              id=""
                            />
                          </div>
                          <div className="p-0">
                            <input
                              type="file"
                              name=""
                              className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                              id=""
                            />
                          </div>
                          <div className="">
                            <a href="" className="delete-record">
                              <svg
                                className="text-primary-red h-8 w-8"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  */}

        {/* details of share holders close */}

        {/* upload documents open */}
        {/* <div>
          <div>
            <div>
              <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                S. N.
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Document Name
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Action
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Remarks
              </div>
            </div>
          </div>
          <div>
            {Exim_upload_details.map((item, index) => {
              return (
                <div className="border-primary-blue border">
                  <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                    {item.sn}
                  </div>
                  <div className="p-0">
                    <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                      {item.ip1}
                      <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                        Upload
                      </button>
                    </p>
                  </div>
                  <div className="p-0">
                    <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      <button className="bg-primary-green rounded-xl px-2 ">
                        view
                      </button>
                      <button className="bg-primary-red rounded-xl px-2">
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="p-0">
                    <div className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      {item.remark}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}
        <div className="text-primary-blue font-Calistoga text-lg mt-6 mb-6 underline">
          4. Upload Documents
          <span className="text-primary-blue underline font-Laila mx-2 ">
            (यो ब्यवसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
            गर्नुहोस् ।)
          </span>
        </div>

        <Documents
          documents_data={Exim_upload_details}
          initialState={data}
          setDocument={setDocsOutput}
        />

        {/* upload documents close */}

        <div className="text-primary-blue font-Calistoga  text-lg underline my-5">
        5. Working Branch
        <span className="text-primary-blue underline font-Laila text-base font-semibold mx-2">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>

        <FormBranch register={register} />
        <FormButtom />
        <FormPayment handleSubmit={handleSubmit} handleClick={handleClick} 
        setUploadProof={setUploadProof}
        dueAmount = {dueAmount}
        setPaidAmount = {setPaidAmount}
        totalAmount={totalAmount}

        />
      </form>
    </div>
  );
};

export default EximCodeRegistration;
